// Need to use the React-specific entry point to import createApi
import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "./axiosBaseQuery/axiosBaseQuery";
import config from "../../config/config";

// Define a service using a base URL and expected endpoints
export const actionPlanDocsListAPI = createApi({
  reducerPath: "actionPlanDocsListAPI",
  baseQuery: axiosBaseQuery({
    baseUrl: config?.appUrl,
  }),
  keepUnusedDataFor: 900,
  tagTypes: ["actionDocs"],
  endpoints: (builder) => ({
    getActionPlanDocsList: builder.query<any, GoalsAndActionPlansArgTypes>({
      query: ({ affiliateCode, aboNumber, year }) => ({
        url: `/am/abo/${affiliateCode}/${aboNumber}/actionplans/year/${year}`,
        method: "GET",
      }),
      providesTags: ["actionDocs"],
    }),
    deleteActionPlanDoc: builder.mutation<any, ABOSuccessionIdType>({
      query: ({ id }) => ({
        url: `/am/abo/actionplan/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["actionDocs"],
    }),
    uploadActionPlanDocs: builder.mutation<any, UploadSuccessionArgTypes>({
      query: ({ affiliateCode, aboNumber, payload }) => ({
        url: `/am/abo/${affiliateCode}/${aboNumber}/actionplan`,
        method: "POST",
        data: payload,
      }),
      invalidatesTags: ["actionDocs"],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetActionPlanDocsListQuery,
  useDeleteActionPlanDocMutation,
  useUploadActionPlanDocsMutation,
} = actionPlanDocsListAPI;
